import React from 'react';
import Link from 'next/link';
import { FacebookIcon, InstagramIcon, LinkedInIcon, TwitterIcon } from '../../atoms/icons/icons';
import { ISocialMediaLinks } from '../../../models/social-media-links/ISocialMediaLinks';

type Props = {
  socialMediaLinks: ISocialMediaLinks;
  onClick?: () => void;
};

export default function SocialMediaLinks({ socialMediaLinks, onClick }: Props) {
  if (!socialMediaLinks) return null;

  const socialIcons = {
    facebook: <FacebookIcon />,
    instagram: <InstagramIcon />,
    linkedin: <LinkedInIcon />,
    twitter: <TwitterIcon />,
  };

  return (
    <>
      {Object.entries(socialMediaLinks).map(
        ([key, { url, title }]) =>
          url ? ( // Check if url is not empty, null, or undefined
            <Link key={key} href={url} title={title} target='_blank' onClick={onClick}>
              {socialIcons[key as keyof ISocialMediaLinks]}
            </Link>
          ) : null, // Render null if the url is not valid
      )}
    </>
  );
}
